import { render, staticRenderFns } from "./List398.vue?vue&type=template&id=0bd99c30"
import script from "./List398.vue?vue&type=script&lang=js"
export * from "./List398.vue?vue&type=script&lang=js"
import style0 from "./List398.vue?vue&type=style&index=0&id=0bd99c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports